module.exports = __webpack_public_path__ + "img/circle-md.375e8f2c.png";